export const recipeTransformerQL2FS = (recipeQL) => ({
  id: recipeQL.Recipe_ID,
  metadata: {
    name: recipeQL.Recipe_Name,
    cookTime: recipeQL.Cooking_Time,
    url: recipeQL.image_url,
    prepTime: recipeQL.prep_time,
    active: recipeQL.Active,
    tags: recipeQL.cuisine,
    categories: recipeQL.Diet,
    description: recipeQL.Description,
    author: recipeQL.author,
    editor: recipeQL.editor,
    maxServing: recipeQL.maxServing,
    minServing: recipeQL.minServing,
    lastEditedAt: recipeQL.lastEditedAt,
    createdSource: recipeQL.created_source,
  },
  steps: recipeQL.steps,
});
export const recipeTransformerFS2QL = (recipe, recipeId = null) => ({
  Active: recipe.metadata.active,
  Recipe_Name: recipe.metadata.name,
  Cooking_Time: recipe.metadata.cookTime,
  image_url: recipe.metadata.url,
  prep_time: recipe.metadata.prepTime,
  cuisine: recipe.metadata.tags,
  Diet: recipe.metadata.categories,
  steps: recipe.steps,
  Description: recipe.metadata.description,
  author: recipe.metadata.author,
  editor: recipe.metadata.editor,
  maxServing: recipe.metadata.maxServing,
  minServing: recipe.metadata.minServing,
  lastEditedAt: recipe.metadata.lastEditedAt,
  Recipe_ID: recipeId || recipe.id,
});

export const recipeE2MetaDataTransformerFS2QL = (recipes) => {
  const recipeMetaDataList = [];
  recipes.forEach((i) => {
    const name = i?.Recipe_Name;
    const cookTime = i?.Cooking_Time;
    const url = i?.image_url;
    const prepTime = i?.prep_time;
    const active = i?.Active;
    const tags = i?.cuisine;
    const maxServing = i?.maxServing;
    const minServing = i?.minServing;
    const categories = i?.Diet;
    const mealType = i?.Meal_Type;
    const hiddenTags = i?.hiddenTags;
    const ingredients = [];
    const allergens = [];
    i.Steps_DBs.forEach((j) => {
      j.SubSteps.forEach((k) => {
        k.Ingredients_DB_SubSteps.forEach((l) => {
          ingredients.push(l.Ingredients_DB.displayName);
          if (l.Ingredients_DB.allergens?.length) {
            l.Ingredients_DB.allergens.forEach((m) => {
              allergens.push(m);
            });
          }
        });
      });
    });
    recipeMetaDataList.push({
      id: i.id,
      metadata: {
        name,
        cookTime,
        url,
        prepTime,
        active,
        tags,
        maxServing,
        minServing,
        categories,
        mealType,
        hiddenTags,
        ingredients,
      },
      allergens,
    });
  });
  return recipeMetaDataList;
};

export const recipeMetaDataTransformerFS2QL = (recipes, ingredients) => {
  const ingredientsData = {};
  if (Array.isArray(ingredients)) {
    ingredients.forEach((ingredient) => {
      ingredientsData[ingredient.id] = {
        allergens: ingredient.allergens,
        displayName: ingredient.displayName,
      };
    });
  } else {
    Object.keys(ingredients).forEach((ingredient_id) => {
      const ingredient = ingredients[ingredient_id];
      ingredientsData[ingredient.id] = {
        allergens: ingredient.allergens,
        displayName: ingredient.displayName,
      };
    });
  }

  const recipeMetaDataList = recipes.map((recipe) => {
    const { updatedAt, lastEditedAt } = recipe;
    const defaultRecipeVar = recipe.Recipe_Variations.find((recipeVar) => recipeVar.default)
    const allergensInRecipe = []
    const ingredientsInRecipe = defaultRecipeVar.ingredients.map((ingredientId) => {

      if (ingredientsData[ingredientId]?.allergens?.length) {
        ingredientsData[ingredientId].allergens.forEach((allergen) => {
          allergensInRecipe.push(allergen)
        })
      }
      return ingredientsData[ingredientId]?.displayName
    })
    return {
      id: recipe.id,
      metadata: {
        name: recipe.name,
        cookTime: defaultRecipeVar.cooking_time,
        url: defaultRecipeVar.image_url,
        prepTime: defaultRecipeVar.prep_time,
        active: recipe.active,
        tags: recipe.cuisine,
        maxServing: defaultRecipeVar.max_serving,
        minServing: defaultRecipeVar.min_serving,
        categories: recipe.diet,
        mealType: recipe.meal_type,
        hiddenTags: recipe.hidden_tags,
        ingredients: ingredientsInRecipe,
        ingredientsListIds: defaultRecipeVar.ingredients,
        createdAt: recipe?.created_at ?? 0,
        rating: recipe?.rating,
        ratingCount: recipe?.ratingCount,
        updatedAt,
        lastEditedAt,
        categoryData: recipe.Recipe_Categories_Map
      },
      allergens: allergensInRecipe
    }
  })
  return recipeMetaDataList;
};

export const recipeMetaDataTransformerWithoutIngredientsFS2QL = (recipes) => {
  const recipeMetaDataList = [];
  recipes.forEach((recipe) => {
    const defaultRecipeVar = recipe.Recipe_Variations.find((recipeVar) => recipeVar.default);
    const { id, name, active, tags, categories, mealType } = recipe;
    const { cookTime, url, prepTime, ingredientsListIds, maxServing, minServing } = defaultRecipeVar;
    const transformedRecipe = {
      id,
      metadata: {
        name,
        cookTime,
        url,
        prepTime,
        active,
        tags,
        maxServing,
        minServing,
        categories,
        mealType,
        hiddenTags: recipe.hidden_tags,
        ingredientsListIds
      },
    };

    recipeMetaDataList.push(transformedRecipe);
  });

  return recipeMetaDataList;
};

export const favoriteRecipeIdsTransformerFS2QL = (recipes) => {
  if (recipes && recipes.length > 0) {
    const favoriteRecipes = [];
    recipes.forEach((recipe) => {
      if (recipe?.recipeId) {
        favoriteRecipes.push(recipe.recipeId);
      }
    });
    return favoriteRecipes;
  }
  return null;
};

export const recipeE3TransformerQL2FS = (recipeQL) => {
  const defaultRecipeVar = recipeQL.Recipe_Variations.find((recipeVar) => recipeVar.default)
  const steps = defaultRecipeVar.RecipeVariations_Steps.map((step) => ({
    id: step.StepsE3.id,
    name: step.StepsE3.name,
    ingredientsTitle: step.StepsE3.ingredientsTitle,
    subSteps: step.StepsE3.Steps_Substeps.map((subStep) => ({ ...subStep.SubstepsE3, stepId: step.StepsE3.id, subStepUId: subStep.id }))
  }))
  return {
    id: recipeQL.id,
    metadata: {
      name: recipeQL.name,
      defaultVariationId: defaultRecipeVar.id,
      cookTime: defaultRecipeVar.cooking_time,
      url: defaultRecipeVar.image_url,
      prepTime: defaultRecipeVar.prep_time,
      active: recipeQL.active,
      tags: recipeQL.cuisine,
      categories: recipeQL.diet,
      description: recipeQL.description,
      author: recipeQL.author,
      editor: recipeQL.editor,
      maxServing: defaultRecipeVar.max_serving,
      minServing: defaultRecipeVar.min_serving,
      lastEditedAt: recipeQL.last_edited_at,
      createdSource: recipeQL.created_source,
      created_by: recipeQL.created_by,
      is_deleted: recipeQL.is_deleted,
      is_public: recipeQL.is_public,
    },
    steps,
  }
}